import './App.css';
import React from 'react';
import { BrowserRouter as BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './Components/Navbar';
import Home from './Pages/Home';
import Characters from './Pages/Characters';
import Dream from './Pages/Dream';
import Ink from './Pages/Ink';

function App() {
  return (
    <>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Navbar/>
        <Routes>
          <Route path='' exact element={<Home />} />
          <Route path='characters' exact element={<Characters />} />
          <Route path='dream' exact element={<Dream />} />
          <Route path='ink-and-shards' exact element={<Ink />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
